import styles from './AppleAppStoreLink.module.scss';

import React, { AllHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'clsx';

type AppleAppStoreLinkProps = Readonly<AllHTMLAttributes<HTMLAnchorElement> & {children?: never}>;

export const AppleAppStoreLink: React.FC<AppleAppStoreLinkProps> = ({ className, ...props }) => {
  const { t } = useTranslation();

  return (
    <a
      title={t('consumerAppFooter.appstore')}
      aria-label={t('consumerAppFooter.appstore')}
      className={cx(styles.appstore, className)}
      href="https://itunes.apple.com/us/app/perka/id428620381"
      target="_blank"
      rel="noopener noreferrer"
      role="button"
      {...props}
    >
      {t('consumerAppFooter.appstore')}
    </a>
  );
};
